import NAV_DATA from '@zola-helpers/client/dist/es/constants/navConstants';
import FeatureFlags from 'util/featureFlags';

import { MegaMenuNavItem } from './types';

const {
  PRIMARY: { PAPER },
} = NAV_DATA;

const getInvites = (): MegaMenuNavItem => {
  const featuredChildren = [
    {
      title: 'FREE Paper Sample',
      path: '/wedding-planning/save-the-date/shop?multi_sample_mode=1&multi_sample_tutorial=1',
    },
    {
      title: 'Letterpress Invitations',
      path: '/wedding-planning/invitations/shop?is_letterpress=is_letterpress',
    },
    {
      title: 'Reception Only Save the Dates',
      path: '/wedding-planning/save-the-date/shop?receptionOnly=elopementandvowrenewal',
    },
  ];

  const categoryChildren = [
    {
      title: 'Save The Dates',
      path: '/wedding-planning/save-the-date/shop',
    },
    {
      title: 'Change The Dates',
      path: '/wedding-planning/change-the-date/shop',
    },
    {
      title: 'Invitations',
      path: '/wedding-planning/invitations/shop',
    },
    {
      title: 'Enclosure Cards',
      path: '/wedding-planning/enclosures/shop',
    },
    {
      title: 'Menus',
      path: '/wedding-planning/menus/shop',
    },
    {
      title: 'Programs',
      path: '/wedding-planning/programs/shop',
    },
    {
      title: 'Thank You Cards',
      path: '/wedding-planning/thank-you-cards/shop',
    },
    {
      title: 'Holiday Cards',
      path: '/wedding-planning/holiday-cards/shop',
      inlineFontIcon: null, // to display the icon => 'gift'
    },
  ];

  if (FeatureFlags.get('digitalSaveTheDate')) {
    const index = categoryChildren.findIndex((elm) => elm.title === 'Change The Dates');
    categoryChildren.splice(index, 0, {
      title: 'Digital Save The Dates',
      path: '/wedding-planning/digital/save-the-date/shop',
    });
  }

  if (FeatureFlags.get('invitesPlaceCards')) {
    const index = categoryChildren.findIndex((elm) => elm.title === 'Thank You Cards');
    categoryChildren.splice(index, 0, {
      title: 'Place Cards',
      path: '/wedding-planning/place-cards/shop',
    });
  }

  const exploreChildren = [
    {
      title: 'About Zola Invites + Paper',
      path: '/wedding-planning/paper',
    },
    {
      title: 'Our Guide to Save the Dates',
      path: '/expert-advice/a-guide-to-save-the-dates',
    },
    {
      title: 'Invites + Paper Expert Advice',
      path: '/expert-advice/topic/invites-paper',
    },
    {
      title: 'Invites + Paper FAQs',
      path: 'https://help.zola.com/hc/en-us/categories/360000753151-Invites-Paper',
    },
  ];

  return {
    title: 'Invites + Paper',
    id: PAPER,
    path: '/wedding-planning/paper',
    parent: 'Invites + Paper', // a bit weird
    callToAction: {
      path: '/wedding-planning/save-the-date/shop',
      title: 'Get Started',
      items: [
        'Hundreds of designs and ways to customize',
        'Free personalized samples, free shipping, and more',
        'Matching suites with free wedding websites',
      ],
    },
    userActionsLinks: [
      {
        title: 'Your Drafts',
        path: '/wedding-planning/projects/drafts',
      },
      {
        title: 'Your Orders',
        path: '/wedding-planning/projects/finished',
      },
      ...(FeatureFlags.get('cardsFavoriting')
        ? [
            {
              title: 'Your Favorites',
              path: '/favorites/paper',
            },
          ]
        : []),
      {
        title: 'Your Guest Addresses',
        path: '/wedding/manage/guests/all',
      },
    ],
    children: [
      {
        headline: 'Featured',
        children: featuredChildren,
      },
      {
        headline: 'Shop By Category',
        children: categoryChildren,
      },
      {
        headline: 'Explore Zola Invites + Paper',
        borderLeft: true,
        children: exploreChildren,
      },
    ],
  };
};

export default getInvites;
